import script from "./serviceChatAiqu.vue?vue&type=script&setup=true&lang=js"
export * from "./serviceChatAiqu.vue?vue&type=script&setup=true&lang=js"

import "./serviceChatAiqu.vue?vue&type=style&index=0&id=01ec1cdc&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ec1cdc"]])

export default __exports__